import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BRAVERMAN;
const apiUrl = process.env.REACT_APP_BRAVERMAN


export const getCustomerProjects = async (customerId: string | any) => {
    try {
        const rezult = await axios.get(`${apiUrl}User/GetAllProjectPerUserAsync?userId=${customerId}`);
        return rezult.data
    } catch (error) {
        // console.error('Error fetching user:', error);
        return [];
    }

}

export const updateProject = (projectData: any) => {
    console.log("projectData");
    console.log(projectData);

    return axios.put(`${apiUrl}Project/Update`, projectData);
}


export const getProject = () => {
    console.log("get projevt 27");

    return axios.get(`${apiUrl}Project`);
}
export const deleteProject = (projectId: string) => {
    return axios.delete(`${apiUrl}Project/Delete/${projectId}`);
}

export const getProjectById = async (projectId: string) => {
    try {
        const response = await axios.get(`${apiUrl}Project/GetById/${projectId}`);
        return response.data;
    }
    catch (error) {
        console.error('Error fetching user:', error);
        return [];
    }
}
export const getProjectByEmail = async (email: string) => {
    try {
        const response = await axios.get(`${apiUrl}Project/GetProjectsByEmail/${email}`);
        return response.data;
    }
    catch (error) {
        console.error('Error fetching user:', error);
        return [];
    }
}

export const GetById = async (projectId: string) => {
    try {
        const response = await axios.get(`${apiUrl}Project/GetById/${projectId}`);
        console.log(response.data);
        debugger
        return response.data;
    }
    catch (error) {
        console.error('Error fetching user:', error);
    }
}

export const updateSinglePayment = async (
    projectId: string,
    paymentNum: number,
    updatedPayment: {
        date: Date;
        amount: number;
    }
) => {
    try {
        const response = await axios.put(
            `${apiUrl}Project/UpdatePayment?projectId=${projectId}&paymentNum=${paymentNum}`,
            updatedPayment
        );
        return response.data;
    } catch (error) {
        console.error("שגיאה בעדכון תשלום:", error);
        throw error;
    }
};